/**
 * prompt 封装, Andrid大于4.2.0版本均可以用
 *
 */

import {
  ERR_OK,
  getWindow
} from '../util';
let theWindow = getWindow();

let __uid = 0;

export function callAndroid(fn, param, callback) {
  let id = __uid++;
  let callbackName = '__bridgeCall__' + id;

  let message = JSON.stringify({
    cmd: fn,
    id,
    params: param,
    callback: callbackName
  });

  theWindow[callbackName] = function (retData) {
    let errno = retData.errno;
    let err = null;
    if (errno !== ERR_OK) {
      let msg = retData.errmsg;
      err = new Error(msg);
    }
    theWindow[callbackName] = function () {};
    // for beatles callback ret json string
    callback.length === 1 ? callback(JSON.stringify(retData.result)) : callback(err, retData.result);
  };

  theWindow.prompt(message);
};

// export const supportPrompt = isAndroid && compareVersion('>4.2.0');



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/core/android.js